import type { SearchPagination, SearchResponse } from '@algolia/client-search';
import { useEffect } from 'react';

import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { scrollToTop } from 'utils/scroll';
import { scrollIntoView } from 'utils/scrollIntoView';

type Args = {
  scrollToId: string | undefined;
  results:
    | (SearchResponse<SearchAlgoliaHit> & Required<SearchPagination>)
    | undefined;
};

export function useSearchPageScrollEffect({ scrollToId, results }: Args) {
  useEffect(() => {
    const hitElement = scrollToId
      ? document.body.querySelector<HTMLElement>(
          `[data-hit-id="${scrollToId}"]`,
        )
      : undefined;

    if (hitElement) scrollIntoView(hitElement);
    else scrollToTop();
  }, [scrollToId, results]);
}
